<ng-container *ngIf="groupNodeData">
  <ng-container
    *ngTemplateOutlet="
      getTemplateRef(groupNodeData.type);
      context: { $implicit: groupNodeData }
    "
  ></ng-container>
</ng-container>

<ng-template #server let-groupNodeData>
  <button
    class="card-server"
    [class.card-selected]="selected"
    (click)="onGroupNodeClick(groupNodeData)"
  >
    <div class="card-server__header-grid">
      <div class="card-server__header">
        <ng-container *ngIf="groupNodeData?.warnings?.length > 0">
          <sh-icon icon="warning" size="xs"></sh-icon>
        </ng-container>
        <sh-text size="header-2" color="secondary">
          {{ groupNodeData.description }} ({{ groupNodeData?.nodes.length }})
        </sh-text>
      </div>

      <ng-container *ngIf="serverMain">
        <div class="card-server__main">
          <div>
            <ng-container *ngIf="serverMain.warnings?.length > 0">
              <sh-icon
                class="server-icon__warning"
                icon="warning"
                size="s"
              ></sh-icon>
            </ng-container>
            <img
              [src]="dnaSyngoviaIconService.getImgIcon(serverMain?.type).src"
              [alt]="dnaSyngoviaIconService.getImgIcon(serverMain?.type).alt"
            />
          </div>
          <sh-text size="header-2" color="primary">
            {{ 'syngovia.label.sn' | translate }} {{ serverMain.serialNumber }}
            <ng-container
              *ngIf="
                serverMain.msl && MASTER === serverMain.msl.toLocaleLowerCase()
              "
            >
              ({{ serverMain.msl }})
            </ng-container>
          </sh-text>
        </div>
      </ng-container>
    </div>

    <div class="card-server__items">
      <ng-container *ngFor="let node of getServerNodes(groupNodeData?.nodes)">
        <button (click)="onServerItemClick($event, node)" class="server__item">
          <ng-container *ngIf="node.warnings?.length > 0">
            <sh-icon
              class="server__item-icon__warning"
              icon="warning"
              size="s"
            ></sh-icon>
          </ng-container>
          <img
            [src]="dnaSyngoviaIconService.getImgIcon(node.type).src"
            [alt]="dnaSyngoviaIconService.getImgIcon(node.type).alt"
          />
          <sh-text size="header-2" color="secondary">
            {{ 'syngovia.label.sn' | translate }} {{ node.serialNumber }}
            <ng-container
              *ngIf="node.msl && MASTER === node.msl.toLocaleLowerCase()"
            >
              ({{ node.msl }})
            </ng-container>
          </sh-text>
        </button>
      </ng-container>
    </div>

    <button
      class="healthcheck-server-button"
      (click)="onHealthcheckClick()"
      tabindex="0"
    >
      <div class="healthcheck-server-info">
        <sh-text size="header-2" class="healthcheck-title">
          {{ 'syngovia.label.healthcheck' | translate }}
        </sh-text>
        <sh-text
          size="title-1"
          color="secondary"
          class="healthcheck-serial-number"
          >SN {{ serverMain?.serialNumber }}</sh-text
        >
      </div>
      <div class="healthcheck-score-container">
        <sh-text class="healthcheck-score">
          {{ serverMain?.healthcheckTotalScore ?? '-' }}
        </sh-text>
        <sh-icon icon="arrow-line-right-s" color="rgb(var(--ui-5))"></sh-icon>
      </div>
    </button>
  </button>
</ng-template>

<ng-template #groupNode let-groupNodeData>
  <button
    class="card-node card-node--{{ groupNodeData.type }}"
    [class.card-selected]="selected"
    (click)="onGroupNodeClick(groupNodeData)"
  >
    <div class="card-node__header">
      <ng-container *ngIf="groupNodeData?.warnings?.length > 0">
        <sh-icon icon="warning" size="xs"></sh-icon>
      </ng-container>

      <sh-text
        class="card-node__header-description"
        size="body-2"
        color="secondary"
      >
        {{ groupNodeData.description }} ({{ groupNodeData?.nodes.length }})
      </sh-text>
    </div>

    <div class="card-node__items">
      <ng-container *ngIf="groupNodeData?.nodes[0] as node">
        <img
          class="node__item group-node__item--{{
            groupNodeData.type
          }} node__item--{{ node.type }}"
          [src]="dnaSyngoviaIconService.getImgIcon(node.type).src"
          [alt]="dnaSyngoviaIconService.getImgIcon(node.type).alt"
        />
      </ng-container>
    </div>
  </button>
</ng-template>
